{
  "title": "Market prices",
  "lead": "Prevailing prices of vegetables and other produce, checked daily by the Municipal Agriculture Office.",
  "emptyTitle": "Market prices aren't published yet",
  "emptyBody": "The Agriculture Office will post daily prices here. Check back soon.",
  "noPricesTitle": "No prices entered yet",
  "noPricesBody": "Prices for this market will appear here once the Agriculture Office enters them.",
  "market": "Market",
  "group": "Group",
  "allGroups": "All",
  "atMarket": "Prices at {market}",
  "asOf": "as of {date}",
  "noPriceYet": "No price yet",
  "perUnit": "{price} per {unit}",
  "perUnitLabel": "per {unit}",
  "range": "{low} to {high}",
  "up": "Up {pct}% since {date}",
  "down": "Down {pct}% since {date}",
  "unchanged": "No change since {date}",
  "openTrendFor": "{name}: see the price trend",
  "note": "Prices are what most sellers asked on that day. They are a guide, not fixed prices.",
  "period": "Period",
  "lastDays": "Last {days} days",
  "showTable": "Show as table",
  "showChart": "Show as chart",
  "trendTitle": "{name}, last {days} days",
  "noTrend": "No prices in this period.",
  "prevailing": "Prevailing",
  "low": "Low",
  "high": "High",
  "trendSummary": "{name} prevailing price over the last {days} days: {first} on {firstDate}, now {last} on {lastDate}. Lowest {low}, highest {high}.",
  "chartKeysHint": "Use the left and right arrow keys to read each day's price.",
  "adminTitle": "Market prices",
  "adminLead": "Enter today's prices, keep the list of commodities and markets, and download the history.",
  "tabPrices": "Daily prices",
  "tabCommodities": "Commodities",
  "tabMarkets": "Markets",
  "tabExport": "Export",
  "setupTitle": "Set up the price board first",
  "setupBody": "Add at least one market and one commodity. Then you can enter prices every day.",
  "addMarket": "Add a market",
  "addCommodity": "Add a commodity",
  "copyAllEmpty": "Copy the last entry into empty rows",
  "copyLast": "Copy last",
  "copyLastFor": "Copy the last entry for {name}",
  "gridHint": "Prices at {market}, in pesos. Only the prevailing price is required. Clear a prevailing price to remove that day's entry.",
  "lastEntry": "Last entry: {price} on {date}",
  "noLastEntry": "No earlier entry",
  "corrected": "Corrected {count}×",
  "prevailingPeso": "Prevailing (₱)",
  "lowPeso": "Low (₱)",
  "highPeso": "High (₱)",
  "noteLabel": "Note",
  "unsaved": "{count} rows changed",
  "noChanges": "No changes yet",
  "savePrices": "Save prices",
  "savedToast": "Saved {count} prices.",
  "fixRows": "Fix the rows marked in red first.",
  "errNumber": "Enter amounts like 28 or 28.50.",
  "errPrevailing": "Enter the prevailing price too.",
  "errLow": "The low price is above the prevailing price.",
  "errHigh": "The high price is below the prevailing price.",
  "historyTitle": "Corrections: {name}",
  "historyBefore": "Before: {price}",
  "historyChanged": "Changed {date} by {name}",
  "addFromCrops": "Add the crops from the LGU crop list",
  "cropsAdded": "Added {count} commodities from the crop list.",
  "cropsNone": "All the crops are already on the list.",
  "noCommoditiesTitle": "No commodities yet",
  "noCommoditiesBody": "Add the vegetables and other produce whose prices you track.",
  "hidden": "Hidden",
  "editName": "Edit {name}",
  "moveUp": "Move {name} up",
  "moveDown": "Move {name} down",
  "editCommodity": "Edit commodity",
  "commodityName": "Commodity",
  "commodityNameHint": "For example: Cabbage (scorpio).",
  "unit": "Unit",
  "unitHint": "For example: kg, bundle, piece.",
  "groupHint": "Optional heading on the public page, for example: Highland vegetables.",
  "showPublicly": "Show on the public price board",
  "marketsLead": "Where prices are checked, for example the vegetable trading post.",
  "noMarketsTitle": "No markets yet",
  "noMarketsBody": "Add the market where your office checks prices.",
  "editMarket": "Edit market",
  "marketName": "Market name",
  "marketNameHint": "For example: Vegetable Trading Post.",
  "location": "Location",
  "exportTitle": "Download price history",
  "exportLead": "A spreadsheet (CSV) of every price your office entered between the two dates.",
  "downloadCsv": "Download CSV"
}
